import { motion } from "framer-motion";
import { useLanguage } from "@/context/LanguageContext";
import Reveal from "@/components/Reveal";

const Process = () => {
  const { t } = useLanguage();

  return (
    <section id="proceso" className="relative border-y border-cy/10 bg-panel py-24 lg:py-32" data-testid="process-section">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-12">
        <div className="grid gap-16 lg:grid-cols-[0.9fr_1.1fr]">
          <div className="lg:sticky lg:top-28 lg:self-start">
            <Reveal>
              <p className="font-mono text-xs uppercase tracking-[0.28em] text-cy">{t.process.label}</p>
              <h2 className="mt-4 font-display text-2xl font-bold leading-[1.15] tracking-tight text-slate-50 sm:text-3xl lg:text-4xl">
                {t.process.title}
              </h2>
              <p className="mt-8 hidden select-none font-display text-[10rem] font-black leading-none text-stroke-cy opacity-40 lg:block" aria-hidden="true">
                05
              </p>
            </Reveal>
          </div>

          <div className="flex flex-col">
            {t.process.steps.map((step, i) => (
              <Reveal key={i} delay={i * 0.06}>
                <motion.div
                  data-testid={`process-step-${i + 1}`}
                  whileHover={{ x: 8 }}
                  transition={{ type: "spring", stiffness: 260, damping: 22 }}
                  className="group flex items-baseline gap-6 border-b border-cy/10 py-8 first:border-t sm:gap-10 sm:py-10"
                >
                  <span className="font-display text-4xl font-black text-stroke-cy transition-all duration-300 group-hover:text-cy group-hover:[-webkit-text-stroke:0px] sm:text-6xl">
                    {String(i + 1).padStart(2, "0")}
                  </span>
                  <div>
                    <h3 className="font-display text-xl font-bold text-slate-50 sm:text-2xl">{step.t}</h3>
                    <p className="mt-2 max-w-md text-sm leading-relaxed text-slate-400 sm:text-base">{step.d}</p>
                  </div>
                </motion.div>
              </Reveal>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Process;
